import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthResolver } from './auth/auth.resolver';
import { ExternalRedirectGuard } from './utility/external-redirect.guard';
import { NavigationComponent } from './utility/navigation/navigation.component';

const routes: Routes = [
  { 
    path: '', 
    loadChildren: () => import('./auth/auth.module').then(m=>m.AuthModule)
  },
  { 
    path: 'mfg', 
    resolve: {
      auth: AuthResolver
    },
    loadChildren: () => import('./mfg/mfg.module').then(m=>m.MfgModule)
  },
  {
    path: '**',
    canActivate: [ExternalRedirectGuard],
    component: NavigationComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
